import React from "react";
import * as S from "./Grid.styles";
import { Productos } from "../../../dtos/Productos";
import ProductoCatalogosSection from "./ProductoCatalogosSection";

const ProductDetail: React.FC<{ data: { data: Productos } }> = ({ data }) => {
  const product = data.data;

  return (
    <S.DetailContainer>
      <S.Fieldset>
        <S.Legend>Datos maestros</S.Legend>
        <S.DetailGrid>
          <S.DetailItem>
            <S.DetailLabel>Código</S.DetailLabel>
            <S.DetailValue>{product.codigo ?? "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Descripción</S.DetailLabel>
            <S.DetailValue>{product.descripcion || "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Capacidad</S.DetailLabel>
            <S.DetailValue>
              {product.capacidad != null
                ? `${product.capacidad} ${product.um ?? ""}`.trim()
                : "N/A"}
            </S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Caducidad (meses)</S.DetailLabel>
            <S.DetailValue>{product.caducidad ?? "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Clave de registro</S.DetailLabel>
            <S.DetailValue>{product.claveRegistro || "N/A"}</S.DetailValue>
          </S.DetailItem>
        </S.DetailGrid>
      </S.Fieldset>

      <S.Fieldset>
        <S.Legend>Datalake / sincronización</S.Legend>
        <S.DetailGrid>
          <S.DetailItem>
            <S.DetailLabel>Línea venta</S.DetailLabel>
            <S.DetailValue>{product.lineavta ?? "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Cód. dotación</S.DetailLabel>
            <S.DetailValue>{product.codigodotacion ?? "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Lista U</S.DetailLabel>
            <S.DetailValue>{product.listaU || "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Dewar</S.DetailLabel>
            <S.DetailValue>{product.dewar || "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Varios</S.DetailLabel>
            <S.DetailValue>{product.varios || "N/A"}</S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Vigente en origen</S.DetailLabel>
            <S.DetailValue>
              {product.vigenteEnFuenteOrigen == null
                ? "N/A"
                : product.vigenteEnFuenteOrigen
                  ? "Sí"
                  : "No"}
            </S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Última sincronización</S.DetailLabel>
            <S.DetailValue>
              {product.fechaUltimaSincronizacionOrigen
                ? new Date(product.fechaUltimaSincronizacionOrigen).toLocaleString()
                : "N/A"}
            </S.DetailValue>
          </S.DetailItem>
          <S.DetailItem>
            <S.DetailLabel>Usuario último cambio</S.DetailLabel>
            <S.DetailValue>{product.usuarioDelUltimoCambio || "N/A"}</S.DetailValue>
          </S.DetailItem>
        </S.DetailGrid>
      </S.Fieldset>

      {product.codigo != null && (
        <S.Fieldset>
          <S.Legend>Configuración de catálogos</S.Legend>
          <ProductoCatalogosSection product={product} />
        </S.Fieldset>
      )}
    </S.DetailContainer>
  );
};

export default ProductDetail;
